import useAuthenticatedFetch from "./useAuthenticatedFetch";

export const useGet = () => {
    const authenticatedFetch = useAuthenticatedFetch();

    function get(endpoint, handleError) {
        return authenticatedFetch(endpoint, {
            method: "GET",
        })
            .then((response) => {
                if (!response.ok) handleError(response.statusText);
                return response;
            }).catch((error) => {
                handleError(error.message);
            });
    }

    return get;
}

export default useGet;